import React from "react";
import PropTypes from "prop-types";
import "./ProfileIcon.scss";

const ProfileIcon = ({ size, src, alt }) => {
  // Determine the className based on the size prop
  const sizeClass = `profile-icon--${size}`;

  return (
    <div className={`profile-icon ${sizeClass}`}>
      <img src={src} alt={alt} className="profile-icon__image" />
    </div>
  );
};

ProfileIcon.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]).isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default ProfileIcon;
